import React, { useEffect } from 'react';
import { FlexBox, Spinner } from '@vp/swan';
import { bugtracker } from '@99designs/design-services-common';
import { __ } from '@99designs/i18n';
import { useCombinedProjects } from '../hooks/useCombinedProjects';
import { DashboardTabs } from './DashboardTabs';

export const Dashboard: React.FC = () => {
    const { error, past, current, loading: projectsLoading } = useCombinedProjects();

    useEffect(() => {
        if (error) {
            bugtracker.notify(error);
        }
    }, [error]);

    return projectsLoading ? (
        <FlexBox alignItems="center" justifyContent="center" mt={12}>
            <Spinner accessibleText={__('Loading')} size={'super'} />
        </FlexBox>
    ) : (
        <DashboardTabs currentRequests={current} pastRequests={past} projectsError={error} />
    );
};
